<template>
    <div>
        <h1 class="page-title">
            Privacy Policy
        </h1>

        <h2 class="mb-4">
            Contents
        </h2>
        <ol class="mb-5 pl-4">
            <li><a href="#_Toc256000000"><em>Important information and who we are</em></a></li>
            <li><a href="#_Toc256000001"><em>The data we collect about you</em></a></li>
            <li><a href="#_Toc256000002"><em>How is your personal data collected?</em></a></li>
            <li><a href="#_Toc256000003"><em>How we use your personal data</em></a></li>
            <li><a href="#_Toc256000004"><em>Disclosures of your personal data</em></a></li>
            <li><a href="#_Toc256000005"><em>International transfers</em></a></li>
            <li><a href="#_Toc256000006"><em>Data security</em></a></li>
            <li><a href="#_Toc256000007"><em>Data retention</em></a></li>
            <li><a href="#_Toc256000008"><em>Your legal rights</em></a></li>
            <li><a href="#_Toc256000009"><em>Glossary</em></a></li>
        </ol>

        <h2
            id="_Toc256000000"
            class="mb-4"
        >
            1. Important information and who we are
        </h2>

        <h3>Introduction</h3>
        <p>
            MyOnline Estate Agency respects your privacy and is committed to protecting your personal data. This privacy
            notice will inform you as to how we look after your personal data when you visit our website (regardless of
            where you visit it from) and tell you about your privacy rights and how the law protects you.
        </p>

        <h3>Purpose of this privacy notice</h3>
        <p>
            This privacy notice aims to give you information on how MyOnline Estate Agency collects and processes your
            personal data including any data you may provide when you sign up to our newsletter, purchase a product or
            service or take part in a competition.
        </p>
        <p>We do not knowingly collect data relating to children.</p>
        <p>
            It is important that you read this privacy notice together with any other privacy notice or fair processing
            notice we may provide on specific occasions when we are collecting or processing personal data about you so
            that you are fully aware of how and why we are using your data. This privacy notice supplements the other
            notices and is not intended to override them.
        </p>

        <h3>Controller</h3>
        <p>
            This privacy notice is issued on behalf of MyOnline Estate Agency so when we mention MyOnline Estate Agency,
            "we", "us" or "our" in this privacy notice, we are referring to the relevant business responsible for
            processing your data.
        </p>
        <p>
            We have appointed a data protection officer (DPO) who is responsible for overseeing questions in relation to
            this privacy notice. If you have any questions about this privacy notice, including any requests to exercise
            your legal rights, please contact the DPO using the details set out below.
        </p>

        <h3>Contact details</h3>
        <p>Our full details are:</p>
        <p>Full name of legal entity: MyOnline Estate Agency</p>
        <p>Name or title: Data Protection Officer</p>
        <p>Email address: GDPR@crosslanegroup.com</p>
        <p>Postal address: Suite 3D MIOC, Styal Road, Manchester, M22 5WB</p>
        <p>Telephone number: 0161 499 7871</p>
        <p>
            You have the right to make a complaint at any time to the Information Commissioner's Office (ICO), the UK
            supervisory authority for data protection issues (www.ico.org.uk). We would, however, appreciate the chance
            to deal with your concerns before you approach the ICO so please contact us in the first instance.
        </p>

        <h3>Your duty to inform us of changes</h3>
        <p>
            It is important that the personal data we hold about you is accurate and current. Please keep us informed if
            your personal data changes.
        </p>

        <h2
            id="_Toc256000001"
            class="mb-4"
        >
            2. The data we collect about you
        </h2>

        <p>
            Personal data, or personal information, means any information about an individual from which that person can
            be identified. It does not include data where the identity has been removed (anonymous data).
        </p>
        <p>We may collect, use, store and transfer different kinds of personal data about you, including:</p>
        <ul>
            <li>
                <strong>Identity Data</strong> includes first name, maiden name, last name, username or similar
                identifier, marital status, title, date of birth and gender.
            </li>
            <li>
                <strong>Contact Data</strong> includes billing address, delivery address, email address and telephone
                numbers.
            </li>
            <li><strong>Financial Data</strong> includes bank account and payment card details.</li>
            <li>
                <strong>Transaction Data</strong> includes [details about payments to and from you and other details of
                products and services you have purchased from us].
            </li>
            <li>
                <strong>Technical Data</strong> includes [internet protocol (IP) address, your login data, browser type
                and version, time zone setting and location, browser plug-in types and versions, operating system and
                platform and other technology on the devices you use to access this website].
            </li>
            <li>
                <strong>Profile Data </strong>includes [your username and password, purchases or orders made by you,
                your interests, preferences, feedback and survey responses].
            </li>
            <li>
                <strong>Marketing and Communications Data </strong>includes your preferences in receiving marketing from
                us and our third parties and your communication preferences.
            </li>
        </ul>
        <p>
            We may also collect, use and share <strong>Aggregated Data</strong> through our website such as statistical
            or demographic data for any purpose. Aggregated Data may be derived from your personal data but is not
            considered personal data in law as this data does <strong>not</strong> directly or indirectly reveal your
            identity. For example, we may aggregate your Usage Data to calculate the percentage of users accessing a
            specific website feature. However, if we combine or connect Aggregated Data with your personal data so that
            it can directly or indirectly identify you, we treat the combined data as personal data which will be used
            in accordance with this privacy notice.
        </p>
        <p>
            We do not collect any <strong>Special Categories of Personal Data</strong> about you (this includes details
            about your race or ethnicity, religious or philosophical beliefs, sex life, sexual orientation, political
            opinions, trade union membership, information about your health and genetic and biometric data). We also do
            not collect any information about criminal convictions or offences.
        </p>

        <h2
            id="_Toc256000002"
            class="mb-4"
        >
            3. How is your personal data collected?
        </h2>

        <p>We use different methods to collect data from and about you including through:</p>
        <ul>
            <li>
                <strong>Direct interactions</strong><strong>.</strong> You may give us your Identity, Contact and
                Financial Data by filling in forms or by corresponding with us by post, phone, email or otherwise.
            </li>
            <li>apply for our products or services;</li>
            <li>create an account on our website;</li>
            <li>subscribe to our service or publications;</li>
            <li>request marketing to be sent to you;</li>
            <li>enter a competition, promotion or survey</li>
            <li>
                <strong>Third parties or publicly available sources.</strong> We may receive personal data about you
                from various third parties and public sources including as set out below:
            </li>
            <li>Technical Data from analytics providers or search information providers.</li>
            <li>Contact, Financial and Transaction Data from providers of technical, payment and delivery services.</li>
            <li>Identity and Contact Data from data brokers or aggregators.</li>
            <li>Identity and Contact Data from publicly availably sources.</li>
        </ul>

        <h2
            id="_Toc256000003"
            class="mb-4"
        >
            4. How we use your personal data
        </h2>

        <p>
            We will only use your personal data when the law allows us to. Most commonly, we will use your personal data
            in the following circumstances:
        </p>
        <ul>
            <li>Where we need to perform the contract, we are about to enter into or have entered into with you.</li>
            <li>
                Where it is necessary for our legitimate interests (or those of a third party) and your interests and
                fundamental rights do not override those interests.
            </li>
            <li>Where we need to comply with a legal or regulatory obligation.</li>
        </ul>
        <h3>Purposes for which we will use your personal data</h3>
        <p>
            We have set out below, in a table format, a description of all the ways we plan to use your personal data,
            and which of the legal bases we rely on to do so. We have also identified what our legitimate interests are
            where appropriate.
        </p>

        <p>
            Note that we may process your personal data for more than one lawful ground depending on the specific purpose
            for which we are using your data. Please <a
                :href="contactLink"
                target="_blank"
            >contact us</a> if you need details about the
            specific legal ground we are relying on to process your personal data where more than one ground has been
            set out in the table below.
        </p>
        <table class="table text-mid-grey my-5">
            <thead>
                <tr>
                    <td>
                        <strong>Purpose/Activity</strong>
                    </td>
                    <td>
                        <strong>Type of data</strong>
                    </td>
                    <td>
                        <strong>Lawful basis for processing including basis of legitimate interest</strong>
                    </td>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        To register you as a new customer
                    </td>
                    <td>
                        (a) Identity

                        (b) Contact
                    </td>
                    <td>
                        Processing which is necessary for the performance of a contract to which you are party
                        or to take steps at your request before entering into such a contract
                    </td>
                </tr>
                <tr>
                    <td>
                        If applicable, to process and deliver your order including:

                        (a) Manage payments, fees and charges

                        (b) Collect and recover money owed to us
                    </td>
                    <td>
                        (a) Identity

                        (b) Contact

                        (c) Financial

                        (d) Transaction
                    </td>
                    <td>
                        (a) Processing which is necessary for the performance of a contract to which you are
                        party or to take steps at your request before entering into such a contract

                        (b) Necessary for our legitimate interests (to recover debts due to us)
                    </td>
                </tr>
                <tr>
                    <td>
                        To manage our relationship with you which will include:

                        (a) Notifying you about changes to our terms or privacy policy

                        (b) Asking you to leave a review or take a survey
                    </td>
                    <td>
                        (a) Identity

                        (b) Contact

                        (c) Profile

                        (d) Marketing and Communications
                    </td>
                    <td>
                        (a) Processing which is necessary for the performance of a contract to which you are
                        party or to take steps at your request before entering into such a contract

                        (b) Necessary to comply with a legal obligation

                        (c) Necessary for our legitimate interests (to keep our records updated and to study how customers
                        use our products/services)
                    </td>
                </tr>
                <tr>
                    <td>
                        To enable you to partake in a prize draw, competition or complete a survey
                    </td>
                    <td>
                        (a) Identity

                        (b) Contact

                        (c) Profile

                        (d) Usage

                        (e) Marketing and Communications
                    </td>
                    <td>
                        Necessary for our legitimate interests (to study how customers use our
                        products/services, to develop them and grow our business)
                    </td>
                </tr>
                <tr>
                    <td>
                        To administer and protect our business and this website (including troubleshooting, data
                        analysis, testing, system maintenance, support, reporting and hosting of data)
                    </td>
                    <td>
                        (a) Identity

                        (b) Contact

                        (c) Technical
                    </td>
                    <td>
                        (a) Necessary for our legitimate interests (for running our business, provision of
                        administration and IT services, network security, to prevent fraud and in the context of a business
                        reorganisation or group restructuring exercise)

                        (b) Necessary to comply with a legal obligation
                    </td>
                </tr>
                <tr>
                    <td>
                        To deliver relevant website content and advertisements to you and measure or understand
                        the effectiveness of the advertising we serve to you
                    </td>
                    <td>
                        (a) Identity

                        (b) Contact

                        (c) Profile

                        (d) Usage

                        (e) Marketing and Communications

                        (f) Technical
                    </td>
                    <td>
                        Necessary for our legitimate interests (to study how customers use our
                        products/services, to develop them, to grow our business and to inform our marketing strategy)
                    </td>
                </tr>
                <tr>
                    <td>
                        To make suggestions and recommendations to you about goods or services that may be of
                        interest to you
                    </td>
                    <td>
                        (a) Identity

                        (b) Contact

                        (c) Technical

                        (d) Usage

                        (e) Profile
                    </td>
                    <td>
                        Necessary for our legitimate interests (to develop our products/services and grow our
                        business)
                    </td>
                </tr>
            </tbody>
        </table>
        <h3>Marketing</h3>
        <p>
            We strive to provide you with choices regarding certain personal data uses, particularly around marketing and
            advertising.
        </p>

        <h3>Promotional offers from us</h3>
        <p>
            We may use your Identity, Contact, Technical, Usage and Profile Data to form a view on what we think you may
            want or need, or what may be of interest to you. This is how we decide which products, services and offers
            may be relevant for you (we call this marketing).
        </p>

        <p>
            You will receive marketing communications from us if you have requested information from us or purchased
            [goods or services] from us [or if you provided us with your details when you entered a competition or
            registered for a promotion] and, in each case, you have not opted out of receiving that marketing.
        </p>

        <h3>Third-party marketing</h3>
        <p>
            We will get your express opt-in consent before we share your personal data with any company outside of
            MyOnline Estate Agency for marketing purposes.
        </p>

        <h3>Opting out</h3>
        <p>
            You can ask us or third parties to stop sending you marketing messages at any time by <a
                :href="contactLink"
                target="_blank"
            >contacting
                us</a> at any time.
        </p>

        <p>
            Where you opt out of receiving these marketing messages, this will not apply to personal data provided to us
            as a result of any activities in relation to the performance of our contract with you.
        </p>

        <h3>Cookies</h3>
        <p>
            <strong>You can set your browser to refuse all or some browser cookies, or to alert you when websites set
                or access cookies. If you disable or refuse cookies, please note that some parts of this website may become
                inaccessible or not function properly.</strong>
        </p><h3>Change of purpose</h3>
        <p>We will only use your personal data for the purposes for which we collected it.</p>

        <p>
            If we need to use your personal data for an unrelated purpose, we will notify you and we will explain the legal
            basis which allows us to do so.
        </p>

        <p>
            Please note that we may process your personal data without your knowledge or consent, in compliance with the
            above rules, where this is required or permitted by law.
        </p>

        <h2
            id="_Toc256000004"
            class="mb-4"
        >
            5. Disclosures of your personal data
        </h2>

        <p>
            We may have to share your personal data with the parties set out below for the purposes set out in the table in
            paragraph 4 above.
        </p>

        <p>
            We require all third parties to respect the security of your personal data and to treat it in accordance with the
            law. We do not allow our third-party service providers to use your personal data for their own purposes and only
            permit them to process your personal data for specified purposes and in accordance with our instructions.
        </p>

        <h2
            id="_Toc256000005"
            class="mb-4"
        >
            6. International transfers
        </h2>

        <p>We do not transfer your personal data outside the European Economic Area (<strong>EEA</strong>).</p>

        <h2
            id="_Toc256000006"
            class="mb-4"
        >
            7. Data security
        </h2>

        <p>
            We have put in place appropriate security measures to prevent your personal data from being accidentally lost,
            used or accessed in an unauthorised way, altered or disclosed. In addition, we limit access to your personal
            data to those employees, agents, contractors and other third parties who have a business need to know. They will
            only process your personal data on our instructions and they are subject to a duty of confidentiality.
        </p>

        <p>
            We have put in place procedures to deal with any suspected personal data breach and will notify you and any
            applicable regulator of a breach where we are legally required to do so.
        </p>

        <h2
            id="_Toc256000007"
            class="mb-4"
        >
            8. Data retention
        </h2>

        <h3>How long will you use my personal data for?</h3>
        <p>
            We will only retain your personal data for as long as necessary to fulfil the purposes we collected it for,
            including for the purposes of satisfying any legal, accounting, or reporting requirements.
        </p>

        <p>
            To determine the appropriate retention period for personal data, we consider the amount, nature, and sensitivity
            of the personal data, the potential risk of harm from unauthorised use or disclosure of your personal data, the
            purposes for which we process your personal data and whether we can achieve those purposes through other means,
            and the applicable legal requirements.
        </p>

        <p>
            Details of retention periods for different aspects of your personal data are available in our retention policy
            which you can request from us by <a
                :href="contactLink"
                target="_blank"
            >contacting us</a>.
        </p>

        <p>In some circumstances you can ask us to delete your data: see below for further information.</p>

        <h2
            id="_Toc256000008"
            class="mb-4"
        >
            9. Your legal rights
        </h2>

        <p>Under certain circumstances, you have rights under data protection laws in relation to your personal data:</p>

        <p>
            <strong>Request access </strong>to your personal data (commonly known as a "data subject access request").
            This enables you to receive a copy of the personal data we hold about you and to check that we are lawfully
            processing it.
        </p>
        <p>
            <strong>Request correction</strong> of the personal data that we hold about you. This enables you to have any
            incomplete or inaccurate data we hold about you corrected, though we may need to verify the accuracy of the new
            data you provide to us.
        </p>

        <p>
            <strong>Request erasure</strong> of your personal data. This enables you to ask us to delete or remove personal
            data where there is no good reason for us continuing to process it. You also have the right to ask us to delete
            or remove your personal data where you have successfully exercised your right to object to processing (see below),
            where we may have processed your information unlawfully or where we are required to erase your personal data to
            comply with local law. Note, however, that we may not always be able to comply with your request of erasure for
            specific legal reasons which will be notified to you, if applicable, at the time of your request.
        </p>

        <p>
            <strong>Object to processing</strong> of your personal data where we are relying on a legitimate interest
            (or those of a third party) and there is something about your particular situation which makes you want to
            object to processing on this ground as you feel it impacts on your fundamental rights and freedoms. You also
            have the right to object where we are processing your personal data for direct marketing purposes. In some
            cases, we may demonstrate that we have compelling legitimate grounds to process your information which
            override your rights and freedoms.
        </p>

        <p>
            <strong>Request restriction of processing</strong> of your personal data. This enables you to ask us to
            suspend the processing of your personal data in the following scenarios: (a) if you want us to establish
            the data's accuracy; (b) where our use of the data is unlawful but you do not want us to erase it;
            (c) where you need us to hold the data even if we no longer require it as you need it to establish, exercise
            or defend legal claims; or (d) you have objected to our use of your data but we need to verify whether we
            have overriding legitimate grounds to use it.
        </p>

        <p>
            <strong>Request the transfer</strong> of your personal data to you or to a third party. We will provide to
            you, or a third party you have chosen, your personal data in a structured, commonly used, machine-readable
            format. Note that this right only applies to automated information which you initially provided consent
            for us to use or where we used the information to perform a contract with you.
        </p>

        <p>
            <strong>Withdraw consent at any time</strong> where we are relying on consent to process your personal data.
            However, this will not affect the lawfulness of any processing carried out before you withdraw your consent.
            If we have sought your consent and you later withdraw such consent, we may not be able to provide certain
            products or services to you. We will advise you if this is the case at the time you withdraw your consent.
        </p>

        <p>
            If you wish to exercise any of the rights set out above, please <a
                :href="contactLink"
                target="_blank"
            >contact us</a>.
        </p>

        <h3>No fee usually required</h3>
        <p>
            You will not have to pay a fee to access your personal data (or to exercise any of the other rights). However, we may
            charge a reasonable fee if your request is clearly unfounded, repetitive or excessive. Alternatively, we may refuse
            to comply with your request in these circumstances.
        </p>

        <h3>What we may need from you</h3>
        <p>
            We may need to request specific information from you to help us confirm your identity and ensure your right to access
            your personal data (or to exercise any of your other rights). This is a security measure to ensure that personal
            data is not disclosed to any person who has no right to receive it. We may also contact you to ask you for further
            information in relation to your request to help clarify the scope of your request.
        </p>

        <h3>Time limit to respond</h3>
        <p>
            We try to respond to all legitimate requests within one month. Occasionally it may take us longer than a month if
            your request is particularly complex or you have made a number of requests. In this case, we will notify you and
            keep you updated.
        </p>

        <h2
            id="_Toc256000009"
            class="mb-4"
        >
            10. Glossary
        </h2>

        <h3>Lawful Basis</h3>
        <p>
            <strong>Legitimate Interest</strong> means the interest of our business in conducting and managing our business to
            enable us to give you the best service/product and the best and most secure experience. We make sure we consider and
            balance any potential impact on you (both positive and negative) and your rights before we process your personal
            data for our legitimate interests. We do not use your personal data for activities where our interests are
            overridden by the impact on you (unless we have your consent or are otherwise required or permitted to by law). You
            can obtain further information about how we assess our legitimate interests against any potential impact on you in
            respect of specific activities by <a
                :href="contactLink"
                target="_blank"
            >contacting</a> us.
        </p>
        <p>
            <strong>Performance of Contract</strong> means processing your data where it is necessary for the performance of a
            contract to which you are a party or to take steps at your request before entering into such a contract.
        </p>
        <p>
            <strong>Comply with a legal or regulatory obligation</strong> means processing your personal data where it is
            necessary for compliance with a legal or regulatory obligation that we are subject to.
        </p>

        <h3>Third Parties</h3>
        <h4>Internal Third Parties</h4>
        <p>
            MyOnline Estate Agency or other companies with shared common ownership act as joint controllers or processors and are
            based within the European Union and provide IT and system administration services and undertake leadership
            reporting.
        </p>
        <h4>External Third Parties</h4>
        <ul>
            <li>
                Service providers acting as processors based in the European Union who provide IT and system administration
                services.
            </li>
            <li>
                Professional advisers acting as processors or joint controllers including lawyers, bankers, auditors and
                insurers based in Europe who provide consultancy, banking, legal, insurance and accounting services.
            </li>
            <li>
                HM Revenue &amp; Customs, regulators and other authorities acting as processors or joint controllers based in
                the United Kingdom who require reporting of processing activities in certain circumstances.
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'PrivacyPolicy',
    data() {
        return {
            contactLink: 'http://moeawp.tdrstaging.co.uk/contact/'
        };
    }
};
</script>

<style lang="scss">

</style>
